'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Menu, X, Plus, LogIn, LogOut, User } from 'lucide-react';
import LocaleSwitcher from './LocaleSwitcher';
import { useAuth } from '@/contexts/AuthContext';

export default function SiteHeaderClient() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch {}
  };

  return (
    <>
      <div className="flex items-center gap-2 sm:gap-3">
        <LocaleSwitcher />
        <Link
          href="/property-management"
          className="hidden sm:flex items-center gap-1.5 px-3 md:px-4 py-2 text-sm font-600 text-white bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-150 active:scale-95"
        >
          <Plus size={16} />
          <span className="hidden md:inline">أضف إعلانك</span>
          <span className="md:hidden">إضافة</span>
        </Link>
        {user ? (
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex items-center gap-1.5 px-3 py-2 text-sm font-500 text-gray-700 bg-gray-100 rounded-lg">
              <User size={15} className="text-primary-500" />
              <span className="hidden md:inline max-w-[100px] truncate text-xs">{user?.email?.split('@')?.[0]}</span>
            </div>
            <button
              onClick={handleSignOut}
              className="flex items-center gap-1.5 px-3 md:px-4 py-2 text-sm font-600 text-gray-600 border border-gray-200 hover:bg-red-50 hover:text-red-600 hover:border-red-200 rounded-lg transition-all duration-150 active:scale-95"
              title="تسجيل الخروج"
            >
              <LogOut size={16} />
              <span className="hidden sm:inline">خروج</span>
            </button>
          </div>
        ) : (
          <Link
            href="/sign-up-login-screen"
            className="flex items-center gap-1.5 px-3 md:px-4 py-2 text-sm font-600 text-primary-500 border border-primary-200 hover:bg-primary-50 rounded-lg transition-all duration-150 active:scale-95"
          >
            <LogIn size={16} />
            <span className="hidden sm:inline">تسجيل الدخول</span>
          </Link>
        )}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="القائمة"
          suppressHydrationWarning
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="absolute top-14 right-0 left-0 bg-white border-b border-gray-100 shadow-lg md:hidden z-50">
          <nav className="flex flex-col p-3 gap-1">
            <Link href="/property-listings" onClick={() => setMobileOpen(false)} className="px-4 py-3 text-sm font-500 text-gray-700 hover:bg-gray-50 rounded-lg">العقارات</Link>
            <Link href="/property-listings?type=sale" onClick={() => setMobileOpen(false)} className="px-4 py-3 text-sm font-500 text-gray-700 hover:bg-gray-50 rounded-lg">للبيع</Link>
            <Link href="/property-listings?type=rent" onClick={() => setMobileOpen(false)} className="px-4 py-3 text-sm font-500 text-gray-700 hover:bg-gray-50 rounded-lg">للإيجار</Link>
            <Link href="/seller-verification" onClick={() => setMobileOpen(false)} className="px-4 py-3 text-sm font-500 text-gray-700 hover:bg-gray-50 rounded-lg">توثيق البائع</Link>
            <Link href="/property-management" onClick={() => setMobileOpen(false)} className="px-4 py-3 text-sm font-500 text-gray-700 hover:bg-gray-50 rounded-lg">إدارة عقاراتي</Link>
            <Link href="/property-management" onClick={() => setMobileOpen(false)} className="mt-2 px-4 py-3 text-sm font-600 text-white bg-primary-500 rounded-lg text-center">+ أضف إعلانك مجاناً</Link>
            {user && (
              <button
                onClick={() => { handleSignOut(); setMobileOpen(false); }}
                className="mt-1 px-4 py-3 text-sm font-500 text-red-600 hover:bg-red-50 rounded-lg text-right"
              >
                تسجيل الخروج
              </button>
            )}
          </nav>
        </div>
      )}
    </>
  );
}